<div *ngIf="isLoading" class="spinner-overlay" aria-live="polite">
    <div class="spinner-content">
        <div class="spinner-centrar">
            <mat-progress-spinner class="small-spinner" mode="indeterminate" diameter="30" color="primary"
                aria-busy="true" role="progressbar" aria-labelledby="loading-text"></mat-progress-spinner>
        </div>
        <h2 id="loading-text">
            Cargando...
        </h2>
    </div>
</div>
